import { CircularDependencyFreeStore } from '../CircularDependencyFreeStore'
import ReviewStore from './store'
import ReviewCenter from './components/ReviewCenter'

const reviewStore = new ReviewStore()

CircularDependencyFreeStore.reviewStore = reviewStore

export { reviewStore as store, ReviewCenter }
